<template>
  <v-card>
    <button @click="$emit('popup_close')" class="close-btn"></button>
    <v-data-table
      :headers="tableHeaders"
      :items="data"
      :page.sync="pagination.current"
      item-key="id"
      show-select
      v-model="selectedTopics"
      @click:row="getSingleArticle"
      class="elevation-1 fill-height fill-width news__list"
      :loading="loading"
      show-expand
      :expanded.sync="tableExpandedItem.data"
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" v-if="selectedArticlesContent">
          <v-card-title
            class="article__title"
            v-if="selectedArticlesContent.title"
          >
            <a
              target="_blank"
              :href="selectedArticlesContent.uri"
              v-html="formated.title"
            />
          </v-card-title>
          <v-select
            style="max-width: 82vw"
            v-model="currCategorySelect"
            :items="selectedArticlesContent.subjects.subject"
            @input="getCategorySelections"
            item-text="name"
            label="Выберите подсвечиваемый   тег"
            item-value="name"
            dense
            outlined
          ></v-select>
          <v-card-text v-html="formated.text" />
          <div class="article__closer">
            <v-tooltip z-index="1000" bottom>
              <template v-slot:activator="{ on, attrs }">
                <button
                  v-bind="attrs"
                  v-on="on"
                  class="article__closer-btn"
                  @click="closeArticle"
                />
              </template>
              <span>{{ $t("tooltips.closeArticle") }}</span>
            </v-tooltip>
          </div>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  props: {
    data: Array,
    screen: String,
    currNodeHash: String,
    searchState: Boolean,
  },
  data: () => ({
    loading: false,
    selectedTopics: [],
    selectedArticlesContent: "",
    tableExpandedItem: {
      isOpen: null,
      data: [],
    },
    pagination: {
      current: 0,
    },
    selections: {
      search: "",
      categories: "",
    },
    selectionsRange: [],
    formated: {
      text: "",
      title: "",
    },
  }),
  watch: {
    /**
     * add to vuex selected articles
     * */

    selectedTopics: function() {
      this.$store.commit("updateSelectedForDownload", {
        selectedTopics: this.selectedTopics,
      });
    },
    /**
     * apply highlight by chosen category selection (select in single article)
     * */
    selectedArticlesContent: function() {
      this.divideText(
        this.selectedArticlesContent.text,
        this.selectedArticlesContent.title
      );
    },
    selections: {
      handler() {
        this.divideText(
          this.selectedArticlesContent.text,
          this.selectedArticlesContent.title
        );
      },
      deep: true,
    },
  },
  mounted() {
    this.selectedTopics = this.$store.state.download.selectedTopics;
    this.data.forEach((article, index) => {
      let formatedDate = new Date(article.publishDate).toLocaleDateString(
        "ru-RU",
        {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
        }
      );
      this.data[index].publishDate = formatedDate;
    });
  },

  computed: {
    /**
     * remove selectable categories, which return from server with empty select range
     * */
    selectMarkableText() {
      if (!this.selectedArticlesContent) {
        return [];
      }
      /*let res = this.selectedArticlesContent.subjects.subject.filter(item => item.selections.selection)*/
      return this.selectedArticlesContent.subjects.subject;
    },
    /**
     * initialization v-data-table headers (watch vuetify documentation)
     * */
    tableHeaders() {
      return [
        {
          text: this.$t("data_table.title"),
          align: "start",
          value: "title",
        },
        { text: this.$t("data_table.publish_date"), value: "publishDate" },
        { text: this.$t("data_table.source"), value: "source", width: "250px" },
        /* { text: this.$t("data_table.rate"), value: "rating" }, */
        { text: this.$t("data_table.relevance"), value: "relevance" },
      ];
    },
  },
  methods: {
    /**
     * close all articles
     * */
    closeArticle() {
      this.tableExpandedItem = [];
      this.tableExpandedItem.isOpen = null;
      this.selectedArticlesContent = "";
      this.currArticleId = "";
    },
    /**
     * request which get sigle article on v-data-table row extention
     * */
    getSingleArticle(e) {
      if (this.tableExpandedItem.isOpen === e.id) {
        this.tableExpandedItem = [];
        this.tableExpandedItem.isOpen = null;
        this.selectedArticlesContent = "";
        this.currArticleId = "";
        return;
      }
      this.$store.commit("startLoader");
      this.loading = true;
      this.selectedArticlesContent = "";
      this.currArticleId = e.id;
      let sendData = {
        nodeHash: this.currNodeHash,
        id: e.id,
        searchActivated: this.searchState,
      };
      this.$axios
        .post(
          "http://core.memo.az/mainwindow/getsinglenewsbyhashandid",
          sendData
        )
        .then((res) => {
          this.loading = false;
          this.$store.commit("stopLoader");
          this.selections.categories = "";
          this.selections.search = "";
          this.selectedArticlesContent = res.data;
          console.log(this.selectedArticlesContent);
          if (res.data.querySelections) {
            this.selections.search = res.data.querySelections.querySelection;
          }
          this.tableExpandedItem.data = [res.data];
          this.tableExpandedItem.isOpen = e.id;

          this.selections.categories = res.data.subjects.subject[0].selections;
          if (res.data.subjects) {
            this.currCategorySelect = res.data.subjects.subject[0].name;
          }
        })
        .finally(() => (this.loaded = true));
    },
    /**
     * divide text for properly highlight on search and category selections
     * */
    divideText(text, title) {
      if (!text) {
        return;
      }
      let res = [];
      let innerText = text;
      let innerTitle = title;
      this.selectionsRange = [];

      //put in selectionsRange search and categories ranges with including type key
      if (
        this.selections.search.length !== 0 &&
        this.selections.categories.selection
      ) {
        this.selections.search.forEach((s) => {
          s.type = "search";
          this.selectionsRange.push(s);
        });
        this.selections.categories.selection.forEach((s) => {
          s.type = "category";
          this.selectionsRange.push(s);
        });
      } else if (
        this.selections.search.length === 0 &&
        this.selections.categories.selection
      ) {
        this.selections.categories.selection.forEach((s) => {
          s.type = "category";
          this.selectionsRange.push(s);
        });
      } else if (
        this.selections.search.length !== 0 &&
        !this.selections.categories.selection
      ) {
        this.selections.search.forEach((s) => {
          s.type = "search";
          this.selectionsRange.push(s);
        });
      }

      if (this.selectionsRange.length !== 0) {
        let ranges = this.selectionsRange;
        let selectText = ranges.reduce((accum, range) => {
          let { start, length, type } = range;
          let markedText = {};
          markedText.type = type;
          if (type === "search") {
            if (title.length > +start) {
              markedText.text = title.substring(+start, +start + +length);
            } else {
              markedText.text = text.substring(
                +start - (title.length + 1),
                +start - (title.length + 1) + +length
              );
            }
          } else {
            if (title.length > +start) {
              markedText.text = title.substring(+start, +start + +length);
            } else {
              markedText.text = text.substring(
                +start - (title.length + 1),
                +start - (title.length + 1) + +length
              );
            }
          }
          return accum.concat(markedText);
        }, []);

        selectText.forEach((selection) => {
          if (selection.type === "category") {
            if (innerTitle.includes(selection.text)) {
              innerTitle = innerTitle.replace(
                selection.text,
                `<mark style="color: #fff; background: #1976d2;">${selection.text}</mark>`
              );
            } else {
              innerText = innerText.replace(
                selection.text,
                `<mark style="color: #fff; background: #1976d2;">${selection.text}</mark>`
              );
            }
          }
        });
        selectText.forEach((selection) => {
          if (selection.type === "search" && selection.text !== "") {
            innerTitle = innerTitle.replaceAll(
              selection.text,
              `<mark style="color: #4e4e4e; background: #ffdc91;">${selection.text}</mark>`
            );
            innerText = innerText.replaceAll(
              selection.text,
              `<mark style="color: #4e4e4e; background: #ffdc91;">${selection.text}</mark>`
            );
          }
        });
      }
      innerText.split("\r").forEach((p) => {
        res.push(`${p}</br>`);
      });
      this.formated.title = innerTitle;
      this.formated.text = res.join("");
      return;
    },
    getCategorySelections(name) {
      this.loading = true;
      let sendData = {
        nodeHash: this.currNodeHash,
        id: this.currArticleId,
        subject: name,
      };
      this.$axios
        .post(
          "http://core.memo.az/mainwindow/GetNewsSelectionsBySubject",
          sendData
        )
        .then((res) => {
          this.loading = false;
          this.selections.categories = res.data;
        })
        .finally(() => (this.loaded = true));
    },
  },
};
</script>
<style scoped lang="scss">
.close-btn {
  position: absolute;
  top: 5px;
  right: 20px;
  height: 33px;
  width: 33px;
  border-radius: 3px;
  box-shadow: 0px 0px 8px 2px rgba(34, 60, 80, 0.2);
  background: #fff;
  transition: all 0.3s ease;
  z-index: 10;
  &:hover {
    background: #1976d2;
    &::before,
    &::after {
      background: #fff;
    }
  }
  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 50%;
    height: 1px;
    background: #4d4d4d;
  }
  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
}
</style>
